import * as types from "../actions/actionTypes";

const initialState = {
  list: {
    totalProperties: 0,
    properties: [],
    lastUpdatedProperty: "",
  },
  byIds : [],
  details: {},
  associatedLeaseList: [],
  names: [],
  cities: [],
  stateProvinces: [],
  countries: [],
  campusFacilities: [],
  propertyTypes: [],
  propertyStatuses: [],
  distinctClientRegions: [],
  allProperties: {},
  utilizations: {},
  propertyPageSize: 10,
};

export default function propertyReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PROPERTIES: {
      const { data } = action.payload;

      return {
        ...state,
        list: data,
        details: {},
      };
    }

    case types.GET_PROPERTY: {
      const { data } = action.payload;

      return {
        ...state,
        details: Array.isArray(data) ? data[0] : data,
      };
    }

    case types.GET_PROPERTY_BY_IDS: {
      const { data } = action.payload;

      return {
        ...state,
        byIds : data,
      };
    }

    case types.GET_PROPERTY_FILTER_OPTIONS: {
      const { data } = action.payload;

      const {
        names,
        cities,
        stateProvinces,
        countries,
        propertyTypes,
        propertyStatuses,
      } = data;

      return {
        ...state,
        names,
        cities,
        stateProvinces,
        countries,
        propertyTypes,
        propertyStatuses,
      };
    }

    case types.GET_PROPERTY_NAMES: {
      const { data } = action.payload;

      return {
        ...state,
        names: data,
      };
    }

    case types.GET_PROPERTY_CITIES: {
      const { data } = action.payload;

      return {
        ...state,
        cities: data,
      };
    }

    case types.GET_PROPERTY_STATE_PROVINCES: {
      const { data } = action.payload;

      return {
        ...state,
        stateProvinces: data,
      };
    }

    case types.GET_PROPERTY_COUNTRIES: {
      const { data } = action.payload;

      return {
        ...state,
        countries: data,
      };
    }

    case types.GET_PROPERTY_CAMPUS_FACILITIES: {
      const { data } = action.payload;

      return {
        ...state,
        campusFacilities: data,
      };
    }

    case types.GET_PROPERTY_TYPES: {
      const { data } = action.payload;

      return {
        ...state,
        propertyTypes: data,
      };
    }

    case types.GET_PROPERTY_STATUSES: {
      const { data } = action.payload;

      return {
        ...state,
        propertyStatuses: data,
      };
    }

    case types.GET_DISTINCT_CLIENT_REGIONS: {
      const { data } = action.payload;

      return {
        ...state,
        distinctClientRegions: data?.length > 0 ? data : ["Not Specified"],
      };
    }

    case types.GET_ASSOCIATED_LEASE: {
      const { data } = action.payload;
      return {
        ...state,
        associatedLeaseList: data,
      };
    }

    case types.GET_ALL_PROPERTIES: {
      const { data } = action.payload;

      return {
        ...state,
        allProperties: data,
      };
    }

    case types.GET_PROPERTIES_PAGE_SIZE: {
      const { data } = action.payload || {};
      return {
        ...state,
        propertyPageSize: data,
      };
    }

    default:
      return state;
  }
}
